import React from 'react'
import cn from 'classnames'
import styled from '@emotion/styled'

import { humanFileSize, pluralize } from 'util/strings'

import styles from './styles.css'

const Header = ({ className, isDesktop, attachments, isUploading }) => {
  if (isDesktop) {
    return (
      <div className={className}>
        <div className="cutout">
          {attachments.length} {pluralize(attachments.length, 'Attachment')}
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn(styles.header, {
        [styles['header-uploading']]: isUploading,
      })}
    >
      <div className={styles.header_title}>Attachments</div>
      <div className={styles.header_total}>
        <div className={cn('Icon Icon-attachment', styles.attachmentIcon)} />
        {isUploading && <div>Uploading</div>}
        {!isUploading && (
          <div>
            {humanFileSize(
              attachments.reduce(
                (totalSize, attachment) => totalSize + attachment.file_size,
                0
              )
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default styled(Header)`
  display: flex;
  align-items: center;
  font-size: ${props => props.theme.fontSize.small};
  font-weight: ${props => props.theme.fontWeight.medium};
  color: ${props => props.theme.color.monochrome.medium};
  padding: 12px 0;

  .cutout {
    color: ${props => props.theme.color.monochrome.black};
    position: relative;
    display: inline-block;
    padding-right: ${props => props.theme.spacing['4']};
    z-index: 2;
  }

  @media print {
    margin-bottom: ${props => props.theme.spacing['5']};
  }
`
